<div id="dept-hindi" class="inner-page">
  <div class="container-fluid px-lg-5">

    <h2 class="title">Department of Hindi</h2>
    <p class="inner-lead mt-3">
      The Department of Hindi at Shah Satnam Ji Girls' College, Sirsa promotes the study of Hindi language and literature, fostering cultural awareness and linguistic excellence. The department offers Hindi at undergraduate and postgraduate levels.
    </p>

    <hr class="divider">

    <h4 class="section-subtitle">Courses Offered</h4>
    <ul class="inner-lead">
      <li>BA Hindi (UG) — 3 Years</li>
      <li>Hindi as a subject in B.Com, B.Sc, BBA, BAJMC</li>
      <li>MA Hindi (PG) — 2 Years</li>
    </ul>

    <hr class="divider">

    <h4 class="section-subtitle">Faculty</h4>
    <div class="table-responsive-inner mt-3">
      <table class="inner-table">
        <thead>
          <tr>
            <th>Sr. No.</th>
            <th>Name</th>
            <th>Qualification</th>
            <th>Designation</th>
          </tr>
        </thead>
        <tbody>
          <tr><td>1</td><td>Ms. Poonam Dhamija</td><td>MA Hindi, B.Ed, M.Phil, STET</td><td>HOD</td></tr>
          <tr><td>2</td><td>Ms. Shalu</td><td>MA Hindi, B.Ed</td><td>Assistant Professor</td></tr>
          <tr><td>3</td><td>Ms. Suman Rani</td><td>MA Hindi, B.Ed, M.Ed</td><td>Assistant Professor</td></tr>
        </tbody>
      </table>
    </div>

    <hr class="divider">

    <h4 class="section-subtitle">Department Activities</h4>
    <h5 class="section-subtitle-orange" style="font-size:1rem;">2023–24</h5>
    <ul class="inner-lead">
      <li>Hindi Diwas Celebration</li>
      <li>World Hindi Diwas</li>
      <li>World Poetry Day</li>
    </ul>
    <h5 class="section-subtitle-orange" style="font-size:1rem;">2022–23</h5>
    <ul class="inner-lead">
      <li>Hindi Diwas Celebration</li>
      <li>International Pie Day</li>
    </ul>
    <h5 class="section-subtitle-orange" style="font-size:1rem;">2021–22</h5>
    <ul class="inner-lead">
      <li>FDP on Advanced Leadership Skills</li>
    </ul>

  </div>
</div>
